import React from 'react'
import { Alert } from '@material-ui/lab'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
  root: {
    '& .MuiAlert-message': {
      display: 'block',
    },
  },
})

const AlertWorkEmail = () => {
  const classes = useStyles()
  return (
    <Alert severity="warning" icon={false} className={classes.root}>
      <b>Using your work email</b> (if you have one) will make it easier for your teammates to join
      you on Foodsby.
    </Alert>
  )
}

export default AlertWorkEmail
